import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconContentBlock12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconContentBlock12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.5 5H7V1h2.75a1.5 1.5 0 0 1 1.5 1.5V5zm2.25-3H8v2h2.25V2.5a.5.5 0 0 0-.5-.5M5 6V3H2.5a.5.5 0 0 0-.5.5V6zm0 1H2v2.5a.5.5 0 0 0 .5.5h2.501zm1 0v3h2.5a.5.5 0 0 0 .5-.5V7zm3.5-1h.5v3.5A1.5 1.5 0 0 1 8.5 11h-6A1.5 1.5 0 0 1 1 9.5v-6A1.5 1.5 0 0 1 2.5 2H6v4z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconContentBlock12);
